// 道具计算方式
const item = {

}
/**
 * 持有物计算方式
 * name:持有物名称
 * lvl:持有物等级
 * 
 */
item.calcItemEffect = function(name,lvl){
    if(name == "MuscleBand"){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value:(1 * Math.ceil(lvl / 2)).toFixed(1)
            },
            {
                en:"AttackSpeed",
                zh:"普通攻击速度",
                value:(0.5 * Math.floor(lvl/2)).toFixed(1) + '%'
            }
        ]
    }
    if(name == 'ScopeLens'){
        return [
            {
                en:"CriticalRate",
                zh:"会心一击率",
                value:(0.4 * Math.ceil(lvl/2)).toFixed(1) + '%'
            },
            {
                en:"CriticalDamamge",
                zh:"会心一击增伤",
                value:(0.8 * Math.floor(lvl/2)).toFixed(1) + '%'
            }
        ]
    }
    if(name == 'ShellBell'){
        return [
            {
                en:"SpAttack",
                zh:"特攻",
                value:(1.6 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"ColddownReduction",
                zh:"招式等待时间",
                value: '-' + ((0.3 * Math.floor(lvl/2)).toFixed(1)) + '%'
            }
        ]
    }
    if(name == 'WiseGlasses'){
        return [
            {
                en:"SpAttack",
                zh:"特攻",
                value: (1 * lvl + 9).toFixed(1)
            },
        ]
    }
    if(name == 'FocusBand'){
        return [
            {
                en:"Defense",
                zh:"防御",
                value: (2 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"SpDefense",
                zh:"特防",
                value: (2 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'EnergyAmplifier'){
        return [
            {
                en:"UniteChargeRate",
                zh:"集结招式计量槽增加速度",
                value: (0.3 * Math.ceil(lvl/2)).toFixed(1) + '%'
            },
            {
                en:"ColddownReduction",
                zh:"招式等待时间",
                value: '-' + ( 0.3 * Math.floor(lvl/2)).toFixed(1) + '%'
            },
        ]
    }
    if(name == 'FloatStone'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (1.6 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"Speed",
                zh:"移动速度",
                value: (10 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'BuddyBarrier'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (15 * lvl).toFixed(1)
            }
        ]
    }
    if(name == 'ScoreShield'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (15 * lvl).toFixed(1)
            }
        ]
    }
    if(name == 'AeosCookie'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (8 * lvl).toFixed(1)
            }
        ]
    }
    if(name == 'AttackWeight'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (0.6 * lvl).toFixed(1)
            }
        ]
    }
    if(name == 'SpecialAttackSpecs'){
        return [
            {
                en:"SpAttack",
                zh:"特攻",
                value: (2 * Math.ceil(lvl/2)).toFixed(1)
            }
        ]
    }
    if(name == 'Leftovers'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (24 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"HPRecovery",
                zh:"回复体力（每五秒）",
                value: (0.6 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'ExpShare'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (16 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"Speed",
                zh:"移动速度",
                value: (10 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'AssaultVest'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (18 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"SpDefense",
                zh:"特防",
                value: (3.4 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'RockyHelmet'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (18 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"Defense",
                zh:"防御",
                value: (3.4 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'RazorClaw'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (1 * Math.ceil(lvl/2)).toFixed()
            },
            {
                en:"CriticalRate",
                zh:"会心一击率",
                value: Number((0.5 * Math.floor(lvl/2)).toFixed(1)) + 0.5 + '%'
            },
        ]
    }
    if(name == 'ChoiceSpecs'){
        return [
            {
                en:"SpAttack",
                zh:"特攻",
                value: (1 * lvl + 9).toFixed(1)
            }
        ]
    }
    if(name == 'WeaknessPolicy'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: Number((10 * Math.ceil(lvl/2)).toFixed(1)) + 60
            },
            {
                en:"Attack",
                zh:"攻击",
                value: (1 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'RescueHood'){
        return [
            {
                en:"Defense",
                zh:"防御",
                value: (2 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"SpDefense",
                zh:"特防",
                value: (2 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'ComboScarf'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (0.8 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"AttackSpeed",
                zh:"普通攻击速度",
                value: (0.6 * Math.floor(lvl/2)).toFixed(1) + '%'
            },
        ]
    }
    if(name == 'CureCrown'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (8 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"Attack",
                zh:"攻击",
                value: (1.2 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'SlickSpoon'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (14 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"SpAttack",
                zh:"特攻",
                value: (2 * Math.floor(lvl/2)).toFixed(1)
            },
        ]
    }
    if(name == 'CurseBangle'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (0.8 * lvl).toFixed(1)
            }
        ]
    }
    if(name == 'CurseIncense'){
        return [
            {
                en:"SpAttack",
                zh:"特攻",
                value: (1.3 * lvl).toFixed(1)
            },
        ]
    }
    if(name == 'ChargingCharm'){
        return [
            {
                en:"Attack",
                zh:"攻击",
                value: (1 * Math.ceil(lvl/2)).toFixed(1)
            },
            {
                en:"Speed",
                zh:"移动速度",
                value: (4 * lvl).toFixed(1)
            },
        ]
    }
    if(name == 'ResonantGuard'){
        return [
            {
                en:"HP",
                zh:"体力",
                value: (15 * lvl).toFixed(1)
            },
            {
                en:"HPRecovery",
                zh:"回复体力（每五秒）",
                value: (0.6 * lvl).toFixed(1)
            },
        ]
    }
    if(name == 'RustedSword'){
        return [
            
        ]
    }
}



export default item


// WEBPACK FOOTER //
// ./src/utils/itemFn.js